import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import SearchIcon from '@material-ui/icons/Search';
import Description from '@material-ui/icons/Description';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import IconButton from '@material-ui/core/IconButton';
import Launch from '@material-ui/icons/Launch';
import { ai } from './../services/TelemetryService';

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    position:"fixed",
    bottom: 0,
    margin: "0 auto",
    left: 0,
    right: 0,
  },
  bottomNavBar:{
    borderTop: "2px solid var(--color-primary)"
  },
  card: {
    maxWidth: "100%",
  },
  media: {
    height: "250px",
    width: "100%"
    },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  }
}));

  

export default function Footer(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState('recents');
  function handleChange(event, newValue) {
    setValue(newValue);
  }
  let highlightCard = null;
  if(props.selectedPhoto !== undefined && props.selectedPhoto !== null && props.displayToggle === "photo"){
    const imageAltText = props.selectedPhoto.title + " by " + props.selectedPhoto.author;
    const titleLengthLimit = 40;
    const title = props.selectedPhoto.title.length > titleLengthLimit ? props.selectedPhoto.title.substring(0,titleLengthLimit) + "..." : props.selectedPhoto.title
    highlightCard = (
      <Card style={{position:"relative",top: 0, maxWidth: "700px", left: 0, right: 0, margin: "0 auto"}}>
  <CardHeader
    title={title}
    subheader={props.selectedPhoto.author}
    action={
      <IconButton onClick={(event) => { ai.appInsights.trackEvent({name: "FullSizePhoto", properties: {"photo": props.selectedPhoto }})}} target="_blank" href={props.selectedPhoto.fullSizeUrl} aria-label="more">
        <Launch />
      </IconButton>
    }
  />
  <CardMedia
    className={classes.media}
    image={props.selectedPhoto.smallSizeUrl}
    title={imageAltText}
    
  />
</Card>
    )
  } else if(props.displayToggle === "about") {
    highlightCard = (<Card style={{position:"relative",top: 0, maxWidth: "700px", left: 0, right: 0, margin: "0 auto"}}>
    <CardHeader
      title={"About VuFinder"}
    />
    <CardContent>
      <Typography variant="body1" color="textPrimary" component="p">
        VuFinder is an app to help photographers find interesting new places to take photos. 
        It could help you plan a trip to a new country or city, or help you discover local shots you didn't know existed. 
        It's powered by Serverless technology and the Flickr API.
      </Typography>
    </CardContent>
  </Card>)
  }
  

    return (
      <div className={classes.root}>
        
        {highlightCard}
        
        <BottomNavigation value={value} onChange={handleChange} className={classes.bottomNavBar}>
          <BottomNavigationAction onClick={(event) => props.setToggle("photo")} label="Search" value="search" style={{color:"var(--color-primary)"}}  icon={<SearchIcon />} />
          <BottomNavigationAction onClick={(event) => props.setToggle("about")} label="About" value="about" style={{color:"var(--color-primary)"}} icon={<Description />} />
        </BottomNavigation>
      </div>
    )
}    
